export function OurAsIsProcess() {
  const steps = [
    {
      number: '1',
      title: 'Contact Us',
      description: 'Fill out our simple form or give us a call. Tell us about your apartment building and your situation.',
      timeline: 'Day 1',
      icon: 'ri-phone-line'
    },
    {
      number: '2',
      title: 'Property Analysis',
      description: 'We review your property details, financials, and current condition. No need for you to make any repairs or improvements.',
      timeline: 'Days 2-3',
      icon: 'ri-file-search-line'
    },
    {
      number: '3',
      title: 'Fair Cash Offer',
      description: 'Receive a no-obligation cash offer based on your property\'s current condition and income potential.',
      timeline: 'Days 4-7',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      number: '4',
      title: 'Quick Due Diligence',
      description: 'We conduct a streamlined inspection and review of documents. We handle all the heavy lifting.',
      timeline: 'Days 8-14',
      icon: 'ri-search-eye-line'
    },
    {
      number: '5',
      title: 'Close & Get Paid',
      description: 'Choose your closing date. We handle all paperwork and you walk away with cash in hand.',
      timeline: 'Days 15-30',
      icon: 'ri-hand-coin-line'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Our Simple AS IS Buying Process
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            When you sell your apartment building AS IS to us, the process is straightforward, fast, and stress-free. Here's exactly what to expect.
          </p>
        </div>

        {/* Process Steps */}
        <div className="max-w-5xl mx-auto mb-16">
          <div className="space-y-8">
            {steps.map((step, index) => (
              <div key={index} className="flex gap-8 items-start">
                <div className="flex flex-col items-center flex-shrink-0">
                  <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center text-white text-3xl font-bold shadow-lg">
                    {step.number}
                  </div>
                  {index < steps.length - 1 && (
                    <div className="w-1 h-24 bg-teal-200 mt-4"></div>
                  )}
                </div>
                <div className="flex-1 bg-gradient-to-br from-teal-50 to-white rounded-2xl p-8 border-2 border-teal-200">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center">
                        <i className={`${step.icon} text-2xl text-white`}></i>
                      </div>
                      <h3 className="text-2xl font-bold">{step.title}</h3>
                    </div>
                    <span className="px-4 py-2 bg-teal-600 text-white rounded-full font-bold text-sm whitespace-nowrap">
                      {step.timeline}
                    </span>
                  </div>
                  <p className="text-lg text-gray-700 leading-relaxed">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits Highlight */}
        <div className="bg-gradient-to-br from-teal-50 to-white rounded-2xl p-10 mb-12 border-2 border-teal-200">
          <h3 className="text-3xl font-bold mb-8 text-center">What Makes Our Process Different</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">No Repairs Needed</h4>
              <p className="text-gray-700">We buy in any condition, no matter how much work is needed</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">All Cash Offers</h4>
              <p className="text-gray-700">No financing contingencies or buyer loan delays</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">Your Timeline</h4>
              <p className="text-gray-700">Close on your schedule, as fast as 7 days or take your time</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold mb-2">We Handle Everything</h4>
              <p className="text-gray-700">All paperwork, tenant coordination, and closing details</p>
            </div>
          </div>
        </div>

        {/* Image */}
        <div className="rounded-2xl overflow-hidden shadow-xl">
          <img
            src="https://public.readdy.ai/ai/img_res/7d18da9997d390a191346b96376c26d1.jpg"
            alt="Apartment building AS IS sale process"
            className="w-full h-[500px] object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}